// import * as React from 'react';
// import { Typography, Box, Button } from '@mui/material';
// import ModalForms from '../Shared/Modals';

// interface ChatItem {
//   input: string;
//   output: any;
//   datetime?: string;
// }

// interface AIChatModalProps {
//   open: boolean;
//   onClose: (data?: any, type?: string) => void;
//   title?: string;
//   aichatData?: ChatItem[];
// }

// const AIChatModal: React.FC<AIChatModalProps> = ({
//   open,
//   onClose,
//   title = 'AI Chat Details',
//   aichatData = [],
// }) => {
//   // Helper to render output safely
//   const renderOutput = (output: any) => {
//     if (!output) return 'No response';
//     // If output is already an object
//     if (typeof output === 'object') {
//       return (
//         <pre
//           style={{
//             whiteSpace: 'pre-wrap',
//             backgroundColor: '#f8f9fa',
//             padding: '8px',
//             borderRadius: '6px',
//             fontSize: '0.85rem',
//             overflowX: 'auto',
//           }}
//         >
//           {JSON.stringify(output, null, 2)}
//         </pre>
//       );
//     } 
//     if (typeof output === 'string' && output.trim().startsWith('{')) {
//       try {
//         const parsed = JSON.parse(output);
//         return (
//           <pre
//             style={{
//               whiteSpace: 'pre-wrap',
//               backgroundColor: '#f8f9fa',
//               padding: '8px',
//               borderRadius: '6px',
//               fontSize: '0.85rem',
//               overflowX: 'auto',
//             }}
//           >
//             {JSON.stringify(parsed, null, 2)}
//           </pre>
//         );
//       } catch (err) { 
//         return output;
//       }
//     } 
//     return output;
//   };

//   return (
//     <ModalForms
//       show={open}
//       handleClose={() => onClose(null, 'cancel')}
//       modalBody={
//         <Box sx={{ maxHeight: '400px', overflowY: 'auto' }}>
//           {aichatData.length === 0 ? (
//             <Typography>No AI Chat data available.</Typography>
//           ) : (
//             aichatData.map((chat, index) => (
//               <Box key={index} sx={{ mb: 2, p: 1, borderBottom: '1px solid #ccc' }}>
//                 <Typography variant="subtitle2" color="textSecondary" gutterBottom>
//                   {chat.datetime
//                     ? new Date(chat.datetime).toLocaleString()
//                     : 'Date/time not available'}
//                 </Typography>

//                 <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
//                   <strong>Input:</strong> {chat.input}
//                 </Typography>

//                 <Typography variant="body1" sx={{ mt: 1 }}>
//                   <strong>Output:</strong>
//                 </Typography>

//                 <Box sx={{ ml: 2 }}>{renderOutput(chat.output)}</Box>
//               </Box>
//             ))
//           )}
//         </Box>
//       }
//       modalHeader={title}
//       modalId="ai-chat-modal"
//       size="md"
//       modalFooter={
//         <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
//           <Button
//             onClick={() => onClose(null, 'cancel')}
//             color="primary"
//             variant="outlined"
//             size="small"
//           >
//             Close
//           </Button>
//         </Box>
//       }
//     />
//   );
// };

// export default AIChatModal;

import * as React from 'react';
import { Box, Button } from '@mui/material';
import ModalForms from '../Shared/Modals';
import AiChatDetail from '../PublicChat/AiChatDetail.tsx';

interface AIChatModalProps {
  open: boolean;
  onClose: (data?: any, type?: string) => void;
  title?: string;
  leadId?: string;
}

const AIChatModal: React.FC<AIChatModalProps> = ({
  open,
  onClose,
  title = 'AI Chat Details',
  leadId,
}) => {
  // Debug log to check leadId
  React.useEffect(() => {
    console.log('AIChatModal received leadId:', leadId);
  }, [leadId]);


  // const AiChatDetailstyle = {
  //   maxWidth: 'unset',
  //   width: '100%',
  //   margin: '0 auto',
  // };

  return (
    <ModalForms
      show={open}
      handleClose={() => onClose(null, 'cancel')}
      modalBody={
        <Box sx={{ overflow: 'hidden' }}>
          {leadId ? (
            <Box className="Ai-chat-new-sec">
              <AiChatDetail leadId={leadId} />
            </Box>
          ) : (
            <Box 
              sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '50vh',
                textAlign: 'center',
                p: 3
              }}
            >
              <Box sx={{ fontSize: 64, color: '#ddd', mb: 2 }}>💬</Box>
              <Box sx={{ fontSize: '1.1rem', fontWeight: 600, color: 'text.primary', mb: 1 }}>
                No Lead ID Found
              </Box>
              <Box sx={{ fontSize: '0.875rem', color: 'text.secondary' }}>
                Unable to load AI chat conversation. Lead ID is missing.
              </Box>
            </Box>
          )}
        </Box>
      }
      modalHeader={title}
      modalId="ai-chat-modal"
      size="lg"
      modalFooter={
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button
            onClick={() => onClose(null, 'cancel')}
            color="primary"
            variant="outlined"
            size="small"
          >
            Close
          </Button>
        </Box>
      }
    />
  );
};

export default AIChatModal;